import { IAggregateStep, IDataSource, IQuery, IQueryBuilderContext, IStepValidationResponse, StepType } from "@types"
import { findSourceById, getSelectedStepDetailsById, handleStepFieldValueChanges, registerStep, validateFieldConfiguration, validateSource, validateStep, validateStepNameAndId } from "@utils"
import React, { useEffect, useState } from "react"
import { updateSource, updateStep } from "../StepConfigUtils"
import { FormSection } from "@components/FormSection/FormSection"
import { SourceSelectorInput } from "../SourceSelector/SourceSelectorInput"
import { AggregateEditor } from "../Aggregate/AggregateEditor"
import { validateAggregation } from "../Aggregate/aggregation-utils"
import Icon from '@images/aggregate.svg'


export function renderStep(context: IQueryBuilderContext, query: IQuery, onChange: (query: IQuery) => void, selectedStepId: string) {
    const { step, index, previousSteps, selectedSources } = getSelectedStepDetailsById(query, selectedStepId)
    const _step: IAggregateStep = Object.assign({}, step as IAggregateStep)

    const [errors, setErrors] = useState<Record<string, string>>({})

    useEffect(() => {
        const { isValid, errors } = validateStep(query, step as IAggregateStep)
        setErrors(errors)
    }, [step])

    async function onValueChange(field: string, value: any, source?: boolean) {
        const _query = await handleStepFieldValueChanges(context, query, selectedStepId, field, value, source)
        onChange(_query)
    }

    const source = findSourceById(query, _step?.source)

    return <React.Fragment>
        <FormSection
            label='Source'
            error={errors?.source}
        >
            <SourceSelectorInput
                source={source}
                onChange={(newSource) => { onValueChange('source', newSource, true) }}
                availableSources={[...previousSteps, ...selectedSources]}
                query={query}
            />
        </FormSection>

        <FormSection
            label='Aggregation'
            error={errors?.aggregation}
            inputMinWidth={'100%'}
        >
            <AggregateEditor
                aggregation={_step.aggregation}
                onChange={updated => onValueChange('aggregation', updated)}
                fields={(source as IDataSource)?.schema || []}
            />
        </FormSection>

    </React.Fragment>
}

function validate(query: IQuery, step: IAggregateStep): IStepValidationResponse {
    const errors: Record<string, string> = validateStepNameAndId(step);

    // validate source
    const source = validateSource(query, step, 'source')
    if (!source.isValid) errors.source = source.error

    // validate aggregation
    const aggregation = validateAggregation(step?.aggregation)
    if (aggregation.isValid) {
        const fields = validateFieldConfiguration(query, step, aggregation.uniqueFields, 'source')
        if (!fields.isValid) errors.aggregation = fields.error
    }
    else errors.aggregation = aggregation.error

    return { isValid: Object.keys(errors).length === 0, errors };
}

registerStep({
    type: StepType.Aggregate,
    name: "Summarize",
    description: "Summarize and aggregate data using sum/average/min/max/count/etc...",
    icon: Icon,
    render: renderStep,
    validate: validate,
    onSelectStep: (basicProps, previousSource) => {
        return { ...basicProps, source: previousSource, aggregation: { fields: [], aggregates: [] } } as IAggregateStep
    },
})